const PREFERRED_CONTACT_LABEL: Record<string, string> = {
    EMAIL: 'Correo electrónico',
    SMS: 'SMS',
    PHONE: 'Teléfono',
    PHYSICAL_MAIL: 'Físico',
    WHATSAPP: 'WhatsApp',
};

const asRecord = (value: unknown): Record<string, unknown> | undefined =>
    value && typeof value === 'object' && !Array.isArray(value)
        ? (value as Record<string, unknown>)
        : undefined;

export const getOrbitCitizen = (
    orbitCase: Record<string, unknown>
): Record<string, unknown> => asRecord(orbitCase.citizen) ?? {};

export const readOrbitString = (
    record: Record<string, unknown>,
    keys: string[]
): string => {
    for (const key of keys) {
        const value = record[key];
        if (value !== undefined && value !== null && value !== '') {
            return String(value);
        }
    }
    return '';
};

export const readOrbitCitizenString = (
    orbitCase: Record<string, unknown>,
    keys: string[]
): string => readOrbitString(getOrbitCitizen(orbitCase), keys);

export const formatOrbitPreferredContactLabel = (value: string): string => {
    const text = value.trim();
    if (!text || text.toUpperCase() === 'NULL') return '';

    return PREFERRED_CONTACT_LABEL[text.toUpperCase()] ?? text;
};

export const resolveOrbitPreferredContact = (
    orbitCase: Record<string, unknown>
): string =>
    formatOrbitPreferredContactLabel(
        readOrbitCitizenString(orbitCase, ['preferred_contact_method'])
    );
